<template>
  <transition name="loader-fade" appear>
    <div
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-white dark:bg-zinc-950"
      v-if="visible"
    >
      <div class="flex flex-col items-center gap-6">
        <img :src="logoSrc" alt="Highfield" class="w-56" loading="eager" />

        <div class="flex items-center justify-center">
          <div
            class="w-12 h-12 border-4 border-transparent rounded-full border-t-black animate-spin dark:border-transparent dark:border-t-white"
          ></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useColorMode } from "@vueuse/core";
// `visible` prop allows parent to control display; default true
const props = defineProps<{ visible?: boolean }>();
const visible = computed(() => props.visible ?? true);

const { value: color } = useColorMode();

const logoSrc = computed(() => {
  // Prefer white logo in dark mode, black in light.
  return color === "dark"
    ? "/images/logos/HighfieldLogos/svg/highfield_long_white.svg"
    : "/images/logos/HighfieldLogos/svg/highfield_long_black.svg";
});
</script>

<style scoped>
.loader-fade-enter-from,
.loader-fade-leave-to {
  opacity: 0;
}
.loader-fade-enter-active,
.loader-fade-leave-active {
  transition: opacity 260ms ease;
}
</style>
